























import Icon from "@/components/Icon.vue";
import {
  DecomojiAction,
  DecomojiViewModel,
} from "@/store/modules/decomoji/models";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component({
  components: {
    Icon,
  },
})
export default class Search extends Vue {
  // viewModel を引き当てる
  @Getter("decomoji/viewModel") decomoji!: DecomojiViewModel;

  // アクションを引き当てる
  @Action("decomoji/updateSearch")
  updateSearch!: DecomojiAction["updateSearch"];

  // 内部プロパティを定義する
  timer: number = 0;

  /**
   * @method - 検索クエリの更新処理を間引いて実行する
   */
  debouncedUpdateSearch(query: string) {
    window.clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.updateSearch(query);
    }, 300);
  }
}
